import './index.css'

import React from 'react'
type Props = {
  src: string
  width: number
  height: number
}

/**
 * A responsive video component that embeds an iframe with aspect ratio preservation
 * @param src - The source URL for the video iframe
 * @param width - The width of the video in pixels
 * @param height - The height of the video in pixels
 * @returns A responsive video container with embedded iframe
 */
const Video = (props: Props): React.ReactElement<'div'> => (
  <div
    className="video"
    style={{
      maxWidth: props.width,
    }}
  >
    <div
      className="video-container"
      style={{
        paddingBottom: (props.height / props.width) * 100 + '%',
      }}
    >
      <iframe
        className="video-iframe"
        src={props.src}
        width={props.width}
        height={props.height}
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        frameBorder="0"
        referrerPolicy="origin"
      />
    </div>
  </div>
)

export default Video
